// File video logic
const wrapper = document.querySelector(".file-wrapper");
if (wrapper) {
  const video = wrapper.querySelector("video");
  const playBtn = wrapper.querySelector(".file-play");
  const stopBtn = wrapper.querySelector(".file-stop");

  if (video && playBtn && stopBtn) {
    playBtn.addEventListener("click", () => {
      video.classList.remove("hidden");
      video.play();
      playBtn.classList.add("hidden");
      stopBtn.classList.remove("hidden");
    });

    stopBtn.addEventListener("click", () => {
      video.pause();
      video.currentTime = 0;
      video.classList.add("hidden");
      stopBtn.classList.add("hidden");
      playBtn.classList.remove("hidden");
    });

    video.addEventListener("ended", () => {
      stopBtn.click();
    });
  }
}

// YouTube video logic
const youtubePlayers = {};

function onYouTubeIframeAPIReady() {
  document.querySelectorAll('.youtube-thumbnail').forEach((thumb) => {
    const videoId = thumb.dataset.videoId;
    const playerContainer = document.getElementById(`player-${videoId}`);
    const playBtn = thumb.querySelector(".youtube-play");
    const stopBtn = thumb.querySelector(".youtube-stop");

    if (!playBtn || !stopBtn || !playerContainer) return;

    playBtn.addEventListener("click", () => {
      thumb.style.display = "none";
      playerContainer.style.display = "block";
      stopBtn.style.display = "inline-flex";

      if (youtubePlayers[videoId]) {
        youtubePlayers[videoId].playVideo();
        return;
      }

      youtubePlayers[videoId] = new YT.Player(playerContainer, {
        videoId: videoId,
        playerVars: {
          controls: 0,
          mute: 1,
          loop: 1,
          playlist: videoId,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
        },
        events: {
          onReady: (event) => event.target.playVideo(),
        },
      });
    });

    stopBtn.addEventListener("click", () => {
      const player = youtubePlayers[videoId];
      if (player) {
        player.stopVideo();
        playerContainer.style.display = "none";
        thumb.style.display = "flex";
        stopBtn.style.display = "none";
      }
    });
  });
}

if (!window.YT) {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
} else {
  onYouTubeIframeAPIReady();
}
